<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.edit') }} {{ $tc('message.allergies', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <b-form @submit="onSubmit" @reset="onReset" v-if="show">
                    <b-container>
                        <b-row>
                            <b-col sm="12">
                                <span  class="obligatoire">*</span>
                                <b-form-group
                                        id="description-group"
                                        :label="$t('message.description')"
                                        label-for="description"
                                >
                                    <b-form-textarea
                                            id="description"
                                            v-model="$v.form.description.$model"
                                            :state="$v.form.description.$dirty ? !(errorshasField('description') || $v.form.description.$error) : null"
                                            required
                                    ></b-form-textarea>

                                    <b-form-invalid-feedback v-if="!$v.form.description.required">
                                        {{ $t('message.requiredField') }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="!$v.form.description.minLength">
                                        {{ $t('message.minCharacters', { n: 7 }) }}
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback v-if="errorshasField('description')">
                                        {{ getErrorsField('description') }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
<!--                            <b-col sm="6">-->
<!--                                <b-form-group-->
<!--                                        id="date-group"-->
<!--                                        :label="$t('message.startDate')"-->
<!--                                        label-for="date"-->
<!--                                >-->
<!--                                    <b-form-input-->
<!--                                            id="date"-->
<!--                                            v-model="$v.form.date.$model"-->
<!--                                            :state="$v.form.date.$dirty ? !(errorshasField('date') || $v.form.date.$error) : null"-->
<!--                                            type="date"-->
<!--                                            @keydown="clearErrorField('date')"-->
<!--                                    ></b-form-input>-->
<!--                                    <b-form-invalid-feedback v-if="errorshasField('date')">-->
<!--                                        {{ getErrorsField('ville') }}-->
<!--                                    </b-form-invalid-feedback>-->
<!--                                </b-form-group>-->
<!--                            </b-col>-->
                        </b-row>
                        <b-row class="justify-content-sm-center" v-if="form.isAuthor || hasMedecinControleRole || hasAdminRole || hasAssistante">
                            <b-button type="submit" variant="primary">
                                {{ $t('message.edit') }}
                            </b-button>

<!--                            <b-button type="reset" variant="danger">-->
<!--                                {{ $t('message.reset') }}-->
<!--                            </b-button>-->
                        </b-row>
                    </b-container>




                </b-form>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required,minLength } from 'vuelidate/lib/validators';

    export default {
        name: "EditAllergy",

        computed: {
            ...mapGetters(["allergy",'hasAdminRole',
                'hasMedecinControleRole',
                'hasAssistante',
                'hasPraticienRole',
                'errors'
            ]),
            can: function (){
                if (this.hasAdminRole){
                    return true;
                }else{
                    return this.hasMedecinControleRole || this.hasPraticienRole || this.hasAssistante;
                }
            },
            form: function() {
                return this.allergy;
            }
        },

        data() {
            return {
                allergy_id: this.$route.params.allergy,
                show: true
            }
        },

        methods: {
            getAllergy: function() {
                let args = {
                    allergy: this.allergy_id
                };
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                };

                this.$store.dispatch('getAllergy', { args, errorMessages });
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {
                        allergy: this.allergy_id,
                        description: this.form.description,
                        date:this.form.date
                    };

                    let successMessage = this.$i18n.t('message.allergyUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateAllergy', { args, errorMessages, successMessage });
                }
            },

            onReset: function(evt) {
                /*evt.preventDefault();

                // Reset our form values
                this.form.intitule = '';
                this.form.description = '';

                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });*/
            },
            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },
            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },
            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });
                this.getErrorsField(field);
            }
        },

        validations: {
            form: {
                description: {
                    required,
                    minLength:minLength(7)
                },
                date: {
                    //
                },

            }
        },

        mounted() {
            // Retrieve allergy
            this.getAllergy();
        }
    }
</script>

<style scoped>

</style>